/* unplugin-vue-components disabled */import { render } from "./AppExpectations.vue?vue&type=template&id=427725d0&scoped=true"
import script from "./AppExpectations.vue?vue&type=script&lang=js"
export * from "./AppExpectations.vue?vue&type=script&lang=js"

import "./AppExpectations.vue?vue&type=style&index=0&id=427725d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427725d0"]])

export default __exports__